module.exports = __webpack_public_path__ + "img/quizz-step-11-5.51fc3887.jpg";